import React from 'react';
import { Container, Header, Image } from 'semantic-ui-react';

import dashboardImage from '../../../images/grafix-banner/dashboardPage.svg';

const Portfolio = () => (
  <Container className="demoImage">
    <Header as='h2' icon textAlign='center'>
      <Header.Content>
        My Portfolio
          </Header.Content>
    </Header>
    <Image src={dashboardImage} size='large' centered={true} />
  </Container>
);

export default Portfolio;